import { Auth } from "aws-amplify";
import account from "@/api/accounts";

export default {
  state: {
    account_id: null,
    display_name: null,
    user_id: null,
    account: null
  },

  mutations: {
    ["ACCOUNT_ID"](state, data) {
      state.account_id = data;
    },
    ["DISPLAY_NAME"](state, data) {
      state.display_name = data;
    },
    ["USER_ID"](state, data) {
      state.user_id = data;
    },
    ["ACCOUNT"](state, data) {
      state.account = data;
    }
  },

  actions: {
    async showAccountID({ commit }) {
      let res = await Auth.currentSession();
      // console.log(res);
      if (res && res["idToken"] && res["idToken"]["payload"]) {
        commit("ACCOUNT_ID", res["idToken"]["payload"]["custom:account_id"]);
        return res["idToken"]["payload"]["custom:account_id"];
      } else {
        return "";
      }
    },
    async showUserId({ commit }) {
      let res = await Auth.currentSession();
      // console.log(res);
      if (res && res["idToken"] && res["idToken"]["payload"]) {
        commit("USER_ID", res["idToken"]["payload"]["custom:user_id"]);
        return res["idToken"]["payload"]["custom:user_id"];
      } else {
        return "";
      }
    },
    async showUsername() {
      let res = await Auth.currentSession();
      // console.log(res);
      if (res && res["idToken"] && res["idToken"]["payload"]) {
        return res["idToken"]["payload"]["cognito:username"];
      } else {
        return "";
      }
    },
    async showProfile({ commit }) {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true
      });
      // console.log(user);
      const { attributes } = user;
      // console.log(attributes);

      commit("DISPLAY_NAME", attributes["custom:display_name"]);

      return {
        username: user.username,
        email: attributes["email"],
        displayName: attributes["custom:display_name"]
      };
    },
    async showCurrentUserInfo() {
      const currentUserInfo = await Auth.currentUserInfo();
      return currentUserInfo;
    },
    async showAccount({ commit }, id) {
      try {
        let params = {
          account_id: id
        };
        let res = await account.show(params);
        commit("ACCOUNT", res.data.data);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateAccountPosition(context, { id, lat, lng }) {
      try {
        let params = {
          account_id: id,
          latitude: lat,
          longitude: lng
        };
        let res = await account.updateAccountPosition(params);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async insertAccount(context, username) {
      try {
        await account.insert({
          user_name: username
        });
      } catch (error) {
        throw error;
      }
    },
    async deleteAccount(context, { comment }) {
      try {
        const account_id = await context.dispatch("showAccountID");
        const user_id = await context.dispatch("showUserId");
        const user_name = await context.dispatch("showUsername");
        let params = {
          account_id: account_id,
          user_id: user_id,
          user_name: user_name,
          comment: comment
        };
        await account.del(params);
      } catch (error) {
        throw error;
      }
    }
  },

  getters: {
    getAccountID(state) {
      return state.account_id;
    },
    getDisplayName(state) {
      return state.display_name;
    },
    getUserId(state) {
      return state.user_id;
    },
    getAccount(state) {
      return state.account;
    }
  }
};
